<script setup>
// Todo: replace vanilla JS with Daniel's go-to player lib?
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import useVideosStore from '../js/stores/videos';
import randomString from '../js/utils/randomString';

// Props.
const props = defineProps({
  videoData: {
    type: Object,
    required: true,
  },
});

// Data.
const iframeApiSrc = `${window.location.protocol}//www.youtube.com/iframe_api`;
const playerId = `player-${randomString()}`;
const player = ref(null);
const poster = ref(null);
const playButton = ref(null);
const { players } = storeToRefs(useVideosStore());

// Methods.
const { addVideo, initYT } = useVideosStore();

const onPlayerReady = () => {
  // Show custom play button when video is ready.
  playButton.value.classList.remove('button--hidden');
  player.value = players.value[playerId];
};

const play = () => {
  // Play the video and hide the custom button.
  playButton.value.classList.add('button--hidden');
  poster.value.classList.add('video__poster--hidden');
  player.value.playVideo();
};

// Mounted.
onMounted(() => {
  initYT();

  // Load YT iframe API (if not already loaded by another video).
  const ytScript = document.querySelector(`[src='${iframeApiSrc}']`);
  if (!ytScript) {
    const tag = document.createElement('script');
    tag.src = iframeApiSrc;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Push video object to store.
  addVideo(playerId, props.videoData?.url?.id, onPlayerReady);
});
</script>

<template>
  <div class="video">
    <div
      class="video__poster"
      ref="poster"
      :style="{ backgroundImage: `url('${videoData.video_image_url}')` }"
      @click.prevent="play">
      <div
        class="button button--play button--youtube"
        ref="playButton"
        @click.prevent="play"></div>
    </div>
    <div :id="playerId" class="video__iframe"></div>
  </div>
</template>
